// components/PreviewCard.tsx

import React, { useEffect, useState } from "react";
import { PackageProps } from "../../store/actionType";
import { CustomTooltip } from "components";
import { CopyIcon } from "assets";
import { copyToClipboard } from "utils/helpers/CopyToClipboard";
import { connect } from "react-redux";
import { fetchMembershipDurationByPackageId } from "modules/membership_plan/commercial_membership_plan/membership_duration/store/action";
import { MembershipDurationsProps } from "modules/membership_plan/commercial_membership_plan/membership_duration/store/actionType";

interface PreviewCardProps {
  items: PackageProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & PreviewCardProps;
const PreviewCard: React.FC<Props> = ({
  items,
  onFetchMembershipDuration,
  fetchMembershipDurationByPackageId,
}) => {
  useEffect(() => {
    onFetchMembershipDuration(items.id);
  }, [onFetchMembershipDuration]);
  const { membershipDuration } = fetchMembershipDurationByPackageId;
  const [copied, setCopied] = useState(false);
  const handleCopy = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const success = await copyToClipboard(items.id ?? "");
    if (success) {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    }
  };
  return (
    <div className="max-h-[80vh] overflow-y-auto hide-scrollbar">
      <div className="w-full dark:bg-white bg-primary-500 mt-5 flex items-center p-2 rounded-t-md">
        <h1 className="text-2xl font-bold dark:text-gray-900 text-white">
          Package :
        </h1>
        <h2 className="text-2xl font-bold dark:text-gray-900 text-gray-200 ml-1">
          {items.name}
        </h2>
      </div>
      <div className="border border-primary-100 p-2 shadow-md">
        <h4 className="mb-2 text-xl font-bold tracking-tight text-gray-700 dark:text-white">
          Package Type : {items.package_type}
        </h4>
        <p className="font-semibold text-gray-600 dark:text-gray-400">
          {items.description}
        </p>
      </div>
      <div className="flex flex-col text-black mt-3">
        <h4 className="font-bold">Membership Duration</h4>
        <div className="grid grid-cols-3 gap-3 mt-2">
          {membershipDuration?.map((item: MembershipDurationsProps) => (
            <div key={item.id} className="border p-2 mb-2 rounded shadow">
              <h4 className="font-semibold">
                {item.duration_type}{" "}
                <CustomTooltip
                  title={copied ? "Id copied!" : "Copy Duration Id"}
                  placement="right"
                >
                  <button
                    onClick={handleCopy}
                    className="p-1 hover:text-blue-600"
                  >
                    <CopyIcon className="size-3" />
                  </button>
                </CustomTooltip>
              </h4>
              <p>Days: {item.number_of_days}</p>
              <p>Price: {item.price}</p>
            </div>
          ))}
        </div>
      </div>
      <div>
        <h2 className="font-bold text-black">Information</h2>
          <p className="font-semibold text-gray-600 dark:text-gray-400">
          {items.information}
        </p>
      </div>
    </div>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchMembershipDurationByPackageId:
      state.membershipDuration?.fetchmembershipDurationState,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  onFetchMembershipDuration: (package_id: string) =>
    dispatch(fetchMembershipDurationByPackageId(package_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviewCard);
